import { Component, model, output } from '@angular/core';
import { PrimengImports } from '../../../../../shared/primeng/primeng.imports';

@Component({
  selector: 'krc-submit-success-dialog',
  standalone: true,
  imports: [PrimengImports],
  templateUrl: './submit-success-dialog.component.html',
  styleUrl: './submit-success-dialog.component.scss',
})
export class SubmitSuccessDialogComponent {
  readonly visible = model(false);

  readonly contactKore = output<void>();
  readonly backToHome = output<void>();
}
